import { call, put, takeLatest } from "redux-saga/effects";
import {
  ManagerPettyCashBudgetAction,
  ManagerPettyCashAction
} from "../../actions";
import * as types from "../../actions/actionTypes";
import * as pettyCashBudgetApi from "../../api/pettyCashBudget/managerPettyCashBudget";
import { toastr } from "react-redux-toastr";
import { goBack, replace, go } from "connected-react-router";
import { SUMMARY_PETTY_CASH_BUDGET_MANAGER } from "../../constants/urls";
import {
  GetFilter,
  GetInitFilter
} from "../../containers/pettyCashBudget/filter";
import { SetMessage } from "../../assets/errorMessages";
import { GetReportFilter } from "../../containers/pettyCashBudgetReport/components/filter/filters";

export function* managerWatcherPettyCashBudget() {
  yield takeLatest(
    types.MANAGER_GET_LIST_PETTY_CASH_BUDGET_REQUEST,
    workerList
  );
  yield takeLatest(
    types.MANAGER_GET_INIT_PETTY_CASH_BUDGET_REQUEST,
    workerInit
  );
  yield takeLatest(types.MANAGER_STORE_PETTY_CASH_BUDGET_REQUEST, workerStore);
  yield takeLatest(types.MANAGER_SHOW_PETTY_CASH_BUDGET_REQUEST, workerShow);
  yield takeLatest(types.MANAGER_GET_PETTY_CASH_BUDGET_REQUEST, workerGet);
  yield takeLatest(
    types.MANAGER_UPDATE_PETTY_CASH_BUDGET_REQUEST,
    workerUpdate
  );
  yield takeLatest(
    types.MANAGER_REMOVE_PETTY_CASH_BUDGET_REQUEST,
    workerRemove
  );
}

async function fetchList(pageNumber) {
  return pettyCashBudgetApi.getList(pageNumber, GetReportFilter());
}

function* workerList(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(ManagerPettyCashBudgetAction.getListSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPettyCashBudgetAction.getListFailure(message));
  }
}

async function fetchInit() {
  const filters = GetInitFilter();
  return pettyCashBudgetApi.getInit(filters);
}

function* workerInit() {
  try {
    const response = yield call(fetchInit);
    yield put(ManagerPettyCashBudgetAction.getInitSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPettyCashBudgetAction.getInitFailure(message));
  }
}

async function fetchStore(data) {
  const filters = GetInitFilter();
  return pettyCashBudgetApi.store({ ...data, ...filters });
}

function* workerStore(action) {
  try {
    const response = yield call(fetchStore, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ManagerPettyCashBudgetAction.storeSuccess(response.data));
    yield put(
      replace(`${SUMMARY_PETTY_CASH_BUDGET_MANAGER}/${response.data.data.id}`)
    );
  } catch (error) {
    SetMessage(error, true);
    yield put(ManagerPettyCashBudgetAction.storeFailure());
  }
}

async function fetchShow(id) {
  return pettyCashBudgetApi.show(id);
}

function* workerShow(action) {
  try {
    const response = yield call(fetchShow, action.id);
    yield put(ManagerPettyCashBudgetAction.showSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPettyCashBudgetAction.showFailure(message));
  }
}

async function fetchGet(id) {
  const filters = GetFilter(id);
  return pettyCashBudgetApi.get(filters);
}

function* workerGet(action) {
  try {
    const response = yield call(fetchGet, action.id);
    yield put(ManagerPettyCashBudgetAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPettyCashBudgetAction.getFailure(message));
  }
}

async function fetchUpdate(id, data) {
  return pettyCashBudgetApi.update(id, data);
}

function* workerUpdate(action) {
  try {
    const response = yield call(fetchUpdate, action.id, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ManagerPettyCashBudgetAction.updateSuccess(response.data));
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(ManagerPettyCashBudgetAction.updateFailure(error));
  }
}

async function fetchRemove(id) {
  return pettyCashBudgetApi.remove(id);
}

function* workerRemove(action) {
  try {
    const response = yield call(fetchRemove, action.id);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ManagerPettyCashBudgetAction.removeSuccess(response.data));
    if (action.reloadCurrentPage) {
      yield put(goBack());
      yield put(ManagerPettyCashAction.getRequest(action.pettyCashId));
      //todo fix maybe

      // yield put(ManagerPettyCashBudgetAction.showByAccountTitles(action.pettyCashId))
    } else {
      yield put(goBack());
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(ManagerPettyCashBudgetAction.removeFailure());
  }
}
